<header class="main__content__header modal-header">
  <h2 class="modal-title">Detalhes Aporte</h2>
  <a class="header__btn__close" (click)="activeModal.close(true)">
    <span aria-hidden="true">X</span>
  </a>
</header>
<main class="main__content__modal modal-body">
  <section class="modal__main__dados_usuario content__modal__header">
    <div class="pl-0 pr-0 mb-3 row">
      <div class="col-12 col-xl-3">
        <span class="content__modal__title">Data do Pagamento</span>
        <p class="content__modal__valor">{{details.paymentDate | date:'dd/MM/yyyy'}}</p>
      </div>
      <div class="col-sm-12 col-xl-3">
        <span class="content__modal__title">Data Referencia</span>
        <p class="content__modal__valor">{{details.referenceDate | date:'dd/MM/yyyy'}}</p>
      </div>
      <div class="col-sm-12 col-xl-3">
        <span class="content__modal__title">Valor</span>
        <p class="content__modal__valor">{{details.valor | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
      <div class="col-sm-12 col-xl-3">
        <span class="content__modal__title">Valor Tributado</span>
        <p class="content__modal__valor">{{details.valueTributary | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
    </div>
  </section>
</main>